import { http } from "@canvas/api";

export interface InventoryProductSearchReq {
  endpoint: "ragnarok.swatch.v1.inventory.product.search";
  query: string;
}

export interface InventorySearchQuery {
  // limit: number | null ,
  // name__contains: string | null,
  // offset: number | null,
  // order_by: number | null
}

export interface InventoryProductSearchRes {
  error: string;
  response: {
    count: number;
    results: any[];
  };
}

export function get(
  req: InventoryProductSearchReq
): Promise<InventoryProductSearchRes> {
  return http
    .GET(`/ragnarok/swatch/v1/inventory/product/search?${req.query}`)
    .then((response: InventoryProductSearchRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
